import List, { HeadCell } from 'components/list/list';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import StandardOrderRow from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/components/order-list/standard-order-row';
import StandardRecommendedOrderListRow from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/components/order-list/standard-recommended-order-list-row';
import { OrderListItem } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order-list-item.type';
import { RecommendedOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/recommendation.type';

type Props = {
  isLoading: boolean;
  orders: OrderListItem[];
  recommendedOrders: RecommendedOrder[];
  isNoResults: boolean;
};

const PAGE_NAME_ID = 'orderFeed.listOrderSupplyPlan';

const StandardOrderList: React.FC<Props> = ({ isLoading, orders, recommendedOrders, isNoResults }) => {
  const intl = useIntl();
  const listOptions: HeadCell[] = [
    { id: 'status', label: '', align: 'center', autoWidth: true },
    { id: 'orderNumber', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.orderNumberLabel` }) },
    { id: 'orderNumber', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.changePossibleLabel` }) },
    {
      id: 'requestedDeliveryDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.requestedDeliveryDateLabel` }),
    },
    {
      id: 'arrivalDate',
      label: intl.formatMessage({ id: 'orderFeed.ofdMySupplyPlan.orders.list.arrivalDate' }),
    },
    {
      id: 'totalOrderQty',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.totalOrderQtyLabel` }),
      align: 'right',
    },
    { id: 'actions', label: '', align: 'right', autoWidth: true },
    { id: 'expand', label: '', align: 'right', autoWidth: true },
  ];

  return (
    <List
      options={listOptions}
      isLoading={isLoading}
      noResult={{
        show: isNoResults,
        text: <FormattedMessage id={`${PAGE_NAME_ID}.orderList.noResults`} />,
      }}>
      {orders.map((order) => (
        <StandardOrderRow key={order.orderNumber} order={order} />
      ))}
      {recommendedOrders.map((recommendedOrder) => (
        <StandardRecommendedOrderListRow
          key={`${recommendedOrder.siteErpId}_${recommendedOrder.date}_${recommendedOrder.scheduleId}`}
          recommendedOrder={recommendedOrder}
          listOptions={listOptions}
        />
      ))}
    </List>
  );
};

export default StandardOrderList;
